/*
	MIT License http://www.opensource.org/licenses/mit-license.php
*/

"use strict";

const RuntimeModule = require("../RuntimeModule");

class HelperRuntimeModule extends RuntimeModule {
	/**
	 * @param {string} name a readable name
	 */
	constructor(name) {
		super(name);
	}
}

module.exports = HelperRuntimeModule;
